import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Breadcrumbs from '../../molecules/Breadcrumbs';
import { Section, Wrapper, Text } from './styles/HeroPodcastDetail.styled';

const HeroPodcastDetail = ({ component, pathname }) => {
  const { t } = useTranslation();

  return (
    <Section id="heroComponent">
      <Wrapper>
        <Breadcrumbs
          resource
          theme="Grid"
          breadcrumbs={[
            {
              pathname: '/',
              title: '',
            },
            {
              pathname: pathname?.includes('/es/')
                ? '/es/resources/podcasts/'
                : '/resources/podcasts/',
              title: t('Podcasts'),
            },
            {
              pathname: '',
              title: component?.metaTags?.title,
            },
          ]}
        />
        <Text>
          <p className="eyebrow">
            {component?.headingKicker ? component?.headingKicker : 'Podcast'}
          </p>
          <h1 className="heading">{component?.metaTags?.title}</h1>
          <p className="subhead">{component?.metaTags?.description}</p>
        </Text>
      </Wrapper>
    </Section>
  );
};

export default HeroPodcastDetail;
